import { render } from "./CompanyOfficials.vue?vue&type=template&id=759b32d2"
import script from "./CompanyOfficials.vue?vue&type=script&lang=js"
export * from "./CompanyOfficials.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__